module.exports = __webpack_public_path__ + "img/browse-vehicles-tabs-red.990fb4d9.png";